import Page from "webPage/Page";
import Ajax from "base/Ajax";
import ValueHelper from "base/ValueHelper";

Page.register('/resources/?$', function () {
    let currentPage = 1;
    let filters = $(".js-filter-form").serializeJSON();
    let request;

    $("body").on("click", ".js-filter-dropdown-btn", function () {
        let dropdown = $(this).attr("data-dropdown");

        let wasOpen = $(this).is(".filter__dropdown-select--active");

        $(".filter__dropdown-select").removeClass("filter__dropdown-select--active");
        $(".filter__dropdown-wrapper").removeClass("filter__dropdown-wrapper--active");

        if (!wasOpen) {
            $(this).addClass("filter__dropdown-select--active");
            $(".filter__dropdown-wrapper[data-dropdown='" + dropdown + "']").addClass("filter__dropdown-wrapper--active");
        }
        return false;
    }).on("click", ".js-toggle-resource", function () {
        if ($(window).outerWidth() >= 960) return true;
        let $resource = $(this).parents(".resource");
        $resource.toggleClass("resource--active");

        if ($resource.is(".resource--active")) {
            $resource.find(".js-view-more-text").text("Hide Details");
        } else {
            $resource.find(".js-view-more-text").text("View Details");
        }
    }).on("click", ".js-load-more", function () {
        let $btn = $(this);
        if ($btn.is(".btn--loading")) return false;
        $btn.addClass("btn--loading");

        loadMore();

        return false;
    }).on("change", ".js-resource-filter", function () {
        updateFilters();

    }).on("submit", ".js-filter-form", function () {
        updateFilters();

        return false;
    }).on('click', function (e) {
        let $target = $(e.target);
        if ($(".filter__dropdown-wrapper--active").length > 0 && !$target.is(".filter__dropdown-wrapper") && $target.parents('.filter__dropdown-wrapper').length === 0 && !$target.is(".js-filter-dropdown-btn") && $target.parents(".js-filter-dropdown-btn").length === 0) {
            $(".filter__dropdown-wrapper").removeClass("filter__dropdown-wrapper--active");
            $(".filter__dropdown-select").removeClass("filter__dropdown-select--active");
        }
    });
    $(window).on("scroll resize", updateStickyLoader);

    function updateFilters() {
        filters = $(".js-filter-form").serializeJSON();
        currentPage = 0;
        loadMore(true);
    }

    updateStickyLoader();


    function loadMore(fullLoading = false) {
        if (fullLoading) {
            $(".js-resources-list").addClass("resources-section__container--loading")
        }
        $(".js-load-more").addClass("btn--loading");
        if (request) request.abort();

        let page = currentPage + 1;

        request = Ajax.get("content", "75b56646a919c294/posts/search", $.extend({}, filters, {
            limit: 10,
            page: page,
            sort: {by: "order", direction: 'ASC'}
        }), Ajax.WEBSITE);
        return request.then((data) => {
            currentPage = page;

            let $list = $(".js-resources-list");

            if (fullLoading) {
                $list.find(".resource").remove();
            }

            data.results.forEach((post) => {

                if (post.activeRevision.values.file.length === 0) return;

                let extension = post.activeRevision.values.file[0].extension.toLowerCase();
                extension = extension.replace(new RegExp('x$'), '');
                let svg_ext = ['ppt', 'pdf', 'doc', 'xls'].indexOf(extension) === -1 ? 'file' : extension;

                let categories = ['sector', 'media', 'strand'].map(((name) =>
                        post.activeRevision.values[name].map((val) => $.extend({inputSlug: name}, val))
                )).reduce((a, b) => a.concat(b), []);

                $list.append(
                    eotwJSXFactory('div', {class: "resource"}, [
                        eotwJSXFactory('div', {class: "resource__header-container"}, [
                            eotwJSXFactory('div', {class: "resource__header-icon-wrapper"}, [
                                eotwJSXFactory('span', {class: "svg-icon resource__header-icon"}).html('<svg><use xlink:href="/includes/svg-icons.svg#' + svg_ext + '"></use></svg>'),
                                eotwJSXFactory('span', {class: "resource__big-size"}, [ValueHelper.format_bytes(post.activeRevision.values.file[0].size, 0, "")])
                            ]),
                            eotwJSXFactory('button', {type: "button", class: "resource__dropdown-cta js-toggle-resource"}, [
                                eotwJSXFactory('span', {class: "resource__dropdown-btn-wrapper"}, [
                                    eotwJSXFactory('h6', {'data-field': "title"}, [post.activeRevision.values.title]),
                                    eotwJSXFactory('div', {class: "resource__dropdown-btn"}, [
                                        eotwJSXFactory('span', {class: "js-view-more-text"}, ["View details"]),
                                        eotwJSXFactory('span')
                                    ])
                                ])
                            ])
                        ]),
                        eotwJSXFactory('div', {class: "resource__dropdown"}, [
                            eotwJSXFactory('div', {class: "resource__dropdown-row"}, [
                                eotwJSXFactory('div', {'data-field': "snippet", class: "resource__snippet", unsafeHtml: post.activeRevision.values.snippet}),
                                eotwJSXFactory('ul', {class: "resource__categories"}, [
                                    categories.map((category, i) => [eotwJSXFactory('li', null, [eotwJSXFactory('a', {href: "/resources?" + category.inputSlug + "[]=" + category.slug + ""}, [category.name]),i < categories.length - 1 ? ',' : '']), " "])
                                ]),
                                eotwJSXFactory('span', {class: "resource__size"}, ["size: ", eotwJSXFactory('strong', null, [ValueHelper.format_bytes(post.activeRevision.values.file[0].size, 0, "")])])
                            ]),
                            eotwJSXFactory('div', {class: "resource__dropdown-row"}, [
                                eotwJSXFactory('a', {href: post.activeRevision.values.file[0].url, target: "_blank", class: "resource__download"}, [
                                    eotwJSXFactory('span', null, ["Download"]),
                                    eotwJSXFactory('span', {class: "svg-icon resource__download-icon"}).html('<svg><use xlink:href="/includes/svg-icons.svg#download"></use></svg>')
                                ])
                            ])
                        ])
                    ])
                )
            });
            $(".js-load-more").removeClass("btn--loading");
            $(".js-resources-list").removeClass("resources-section__container--loading")
            if (currentPage >= data.pages.max) {
                $(".js-buttons-wrap").hide();
            } else {
                $(".js-buttons-wrap").show();
            }
        }).catch((e) => {
            $(".js-load-more").removeClass("btn--loading");
            $(".js-resources-list").removeClass("resources-section__container--loading")

            console.log(e);
            alert(e.message);
        });
    }

    function updateStickyLoader() {
        let $header = $(".header");
        let $list = $(".js-resources-list");
        let $loader = $(".resources-section__loader-icon");

        if ($header.length === 0 || $list.length === 0 || $loader.length === 0) return;


        let scrollTop = $(window).scrollTop() + $header.position().top + $header.outerHeight();
        let scrollCenter = scrollTop + ($(window).height() / 2);

        let listTop = $list.offset().top;
        let listBottom = listTop + $list.outerHeight();

        let loaderTop = listTop + 250;

        if (scrollCenter < loaderTop) {
            //At top
            $loader.removeClass("resources-section__loader-icon--bottom resources-section__loader-icon--sticky").addClass("resources-section__loader-icon--top").css("left", "");
        } else if (scrollCenter > listBottom) {
            //At bottom
            $loader.removeClass("resources-section__loader-icon--top resources-section__loader-icon--sticky").addClass("resources-section__loader-icon--bottom").css("left", "");
        } else {
            //Sticky
            $loader.removeClass("resources-section__loader-icon--top resources-section__loader-icon--bottom").addClass("resources-section__loader-icon--sticky").css("left", $list.offset().left + $list.width() / 2);
        }
    }
});
